/**
 * Author:hong.rong
 * Desc:倒计时
 * Date:2021-04-19
 */

import * as React from 'react'

const { useState, useEffect } = React

interface CountDownProps {
  seconds: number
  render: (clickFn: () => void, disabled: boolean, current: number) => React.ReactElement
}

const CountDown: React.FC<CountDownProps> = ({ seconds, render }) => {
  const [timing, setTiming] = useState(false)
  const [current, setCurrent] = useState(seconds)

  useEffect(() => {
    let interval: NodeJS.Timeout
    if (timing) {
      interval = setInterval(() => {
        setCurrent(preSecond => {
          if (preSecond <= 1) {
            setTiming(false)
            clearInterval(interval)
            return seconds
          } else {
            return preSecond - 1
          }
        })
      }, 1000)
    }
    return () => clearInterval(interval)
  }, [timing])

  return <React.Fragment>{render(() => setTiming(true), timing, current)}</React.Fragment>
}
export default CountDown
